"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.OptimizationPrefsToJSON = exports.OptimizationPrefsFromJSONTyped = exports.OptimizationPrefsFromJSON = exports.OptimizationPrefs = void 0;
/**
 * Objective for a campaign. UNSET should not be used.
 * @export
 */
exports.OptimizationPrefs = {
    Unset: 'UNSET',
    Reach: 'REACH',
    EvenImpressionDelivery: 'EVEN_IMPRESSION_DELIVERY',
    Clicks: 'CLICKS',
    VideoViews: 'VIDEO_VIEWS',
    PodcastStreams: 'PODCAST_STREAMS',
    Guaranteed: 'GUARANTEED',
    AppInstalls: 'APP_INSTALLS',
    WebsiteVisits: 'WEBSITE_VISITS',
    LeadGen: 'LEAD_GEN'
};
function OptimizationPrefsFromJSON(json) {
    return OptimizationPrefsFromJSONTyped(json, false);
}
exports.OptimizationPrefsFromJSON = OptimizationPrefsFromJSON;
function OptimizationPrefsFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.OptimizationPrefsFromJSONTyped = OptimizationPrefsFromJSONTyped;
function OptimizationPrefsToJSON(value) {
    return value;
}
exports.OptimizationPrefsToJSON = OptimizationPrefsToJSON;
